"use strict";
var Observable_1 = require('../../Observable');
var timer_1 = require('../../observable/timer');
Observable_1.Observable.timer = timer_1.timer;
//# sourceMappingURL=timer.js.map


//////////////////
// WEBPACK FOOTER
// C:/Works/Respite/respite_app/UI/~/rxjs/add/observable/timer.js
// module id = ../../../../rxjs/add/observable/timer.js
// module chunks = 4